// extracted by mini-css-extract-plugin
module.exports = {"about":"about-module--about--34sZ_","text":"about-module--text--jtNPO"};